import './topPage.css'
import "bootstrap-icons/font/bootstrap-icons.css";



function topPage() {
  return (
      <div className='btn-totop'>
         <a href='#' ><i className="bi bi-arrow-up-square-fill"></i></a>
      </div>
  )
}
export default topPage;